export var raRelationshipsLanguageFrench = {
    'ra-relationships': {
        duallistinput: {
            select: 'Sélectionner',
            unselect: 'Désélectionner',
            availableItems: 'Choix disponibles',
            selectedItems: 'Choix sélectionnés',
        },
    },
};
